import myReportsSlice from './slice';

export const { fetchMyReports, fetchMyReportsError, fetchMyReportsSuccess, fetchMyReportsSearch, fetchMyReportsEnhancedSearch } =
  myReportsSlice.actions;
export default myReportsSlice.reducer;

export * from './types';
